import { SMALL_MODAL } from 'consts/modalStyles'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const DUPLICATE_WORKSPACE_DASHBOARD_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/transfer-dashboard-modal/index.tsx',
  name: 'Duplicates a Workspace Dashboard',
  message: 'Failed to duplicate a dashboard from the workspace context',
}

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  overlay: {
    ...SMALL_MODAL.overlay,
  },
  content: {
    ...SMALL_MODAL.content,
    padding: '24px',
    overflow: 'visible',
    width: '512px',
  },
}
